import { createCrudActions } from '../utils/crudGenerator';

const formatEstablishments = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchEstablishments,
    create: createEstablishment,
    update: updateEstablishment,
    delete: deleteEstablishments
} = createCrudActions('ESTABLISHMENT', "Establecimiento", formatEstablishments);